import { SET_NOTIFICATIONS, NOTIFICATIONS_CLEANUP } from './types';

export const initialState = {
	read: [],
	unread: [],
};

function getNotifications(state = initialState, action) {
	const { read = [], unread = [] } = action.payload || initialState;
	switch (action.type) {
		case SET_NOTIFICATIONS:
			return {
				read,
				unread,
			};
		case NOTIFICATIONS_CLEANUP:
			return { ...initialState };

		default:
			return state;
	}
}

export default getNotifications;
